import { render } from "./Nurses.vue?vue&type=template&id=897fc4fe&scoped=true"
import script from "./Nurses.vue?vue&type=script&lang=js"
export * from "./Nurses.vue?vue&type=script&lang=js"

import "./Nurses.vue?vue&type=style&index=0&id=897fc4fe&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-897fc4fe"

export default script